<template>
  <va-modal
    :value="isOpen"
    id="callRatingDetailsModal"
    ref="callRatingDetailsModal"
    @cancel="onCancel"
    :hideDefaultActions="true"
  >
    <div slot="header" class="d-flex justify--space-between">
      <span
        class="modal-title">{{
          $t('clinical.call_rating_modal_title', {appointment_info: `${callRequestAppointment.person.name} (${moment(callRequestAppointment.start).format('YYYY-MM-DD HH:mm')})`})
        }}</span>
    </div>
    <section class="evollu-form">
      <h5> {{ $t('clinical.appointment.title') }}</h5>
      <div class="form-row">
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('tables.columns.created_at') }}:</span>
          {{ moment(callRequestAppointment.created_at).format('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.appointment_date') }}:</span>
          {{ moment(callRequestAppointment.start).format('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.appointment_started_at') }}:</span>
          {{ moment(callRequestAppointment.started_at).format('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.appointment_ended_at') }}:</span>
          {{ moment(callRequestAppointment.ended_at).format('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.person.label') }}:</span> {{ callRequestAppointment.person.name }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.facility') }}:</span> {{ callRequestAppointment.facility.name }}
        </div>
      </div>
      <h5>{{ $t('clinical.appointments.dispenser') }}</h5>
      <div class="row mb-1">
        <label class="is-bold">{{ $t('clinical.appointments.dispenser') }}:</label>&nbsp;
        <span>
          {{ dispenserName || $t('clinical.appointments.undefined_user') }}
        </span>
      </div>

      <div class="row">
        <label class="is-bold ">{{ $t('clinical.call_ratings.dispenser_rating') }} </label>
        &nbsp;
        <va-rating v-if="callRequestAppointment.dispenser_rating"
                   v-model="callRequestAppointment.dispenser_rating"
                   :readonly="true"
                   size="medium"
                   color="info"
                   style="padding-top: 3px"/>
        <span v-else> N/A </span>
      </div>

      <div>
        <label class="is-bold ">{{ $t('clinical.call_ratings.dispenser_comment') }} </label>
        <va-input
          :value="callRequestAppointment.dispenser_comment || $t('clinical.call_ratings.no_comment')"
          type="textarea"
          :min-rows="3"
          :readonly="true"
          :disabled="true"
        />
      </div>
      <hr>
      <h5>{{ $t('clinical.appointments.audiologist') }}</h5>
      <div class="row mb-1">
        <label class="is-bold ">{{ $t('clinical.appointments.audiologist') }}:</label>&nbsp;
        <span>
          {{ audiologistName || $t('clinical.appointments.undefined_user') }}
          </span>
      </div>

      <div class="row">
        <label class="is-bold ">{{ $t('clinical.call_ratings.audiologist_rating') }}</label>
        &nbsp;
        <va-rating v-if="callRequestAppointment.audiologist_rating"
                   v-model="callRequestAppointment.audiologist_rating"
                   :readonly="true"
                   size="medium"
                   color="info"
                   style="padding-top: 3px"/>
        <span v-else> N/A </span>
      </div>

      <div>
        <label class="is-bold ">{{ $t('clinical.call_ratings.audiologist_comment') }} </label>
        <va-input
          :value="callRequestAppointment.audiologist_comment || $t('clinical.call_ratings.no_comment')"
          type="textarea"
          :min-rows="3"
          :readonly="true"
          :disabled="true"
        />
      </div>
    </section>
  </va-modal>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    callRequestAppointment: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  computed: {
    dispenserName: function () {
      const dispenser = _.get(this.callRequestAppointment, 'parent.user', null)
      return dispenser ? dispenser.nickname || dispenser.name : null
    },
    audiologistName: function () {
      const audiologist = _.get(this.callRequestAppointment, 'user', null)
      return audiologist ? audiologist.nickname || audiologist.name : null
    },
  },
  methods: {
    onCancel: function () {
      this.$emit('modalClosed')
      setTimeout(() => {
        this.isOpen = false
      }, 500)
    }
  }
}
</script>
